import React from "react";
import "./career.scss";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import { Link } from "react-router-dom";

const Career = () => {
  return (
    <>
    <Navbar />
    <div className="career-wrapper">
      <div className="career-left">
        <h4 className="subtitle">Career Opportunity</h4>
        <h1 className="title">
          Build your career with <br /> Daily Help United
        </h1>

        <p>
          Our goal each day is to ensure that our service users’ needs are not
          only met but exceeded.
        </p>

        <p>
          We are looking for people who are as driven as we are to improve the
          quality of life for those we serve. It’s an incredibly rewarding
          mission that our team is dedicated to achieving.
        </p>

        <p>
          Owners, support staff, caregivers and more all play key roles in
          empowering seniors and adults with disabilities with the support they
          need. It’s not just a bonus—in our eyes, it’s the basis of everything
          we do. If you’d like to help us live out our mission, join our team!
        </p>

        <p>
          Our roles are specialised, and you can develop your skills and enhance
          your career within healthcare.
        </p>
      </div>

      <div className="career-card">
        <h3 className="card-title">Healthcare Assistant</h3>
        <p>
          We provide all our healthcare teams with specialist training to
          support them in looking after our clients to the highest possible
          standards.
        </p>

        <h4>Job Responsibilities:</h4>
        <ul className="list">
          <li>Provide assistance, personal care, activities and companionship</li>
          <li>Be alert to residents’ needs, health and wellbeing</li>
          <li>Respect residents’ dignity and privacy</li>
          <li>
            Work with residents and families to deliver tailored care
          </li>
          <li>Assist with mealtimes and safe moving</li>
          <li>Maintain accurate records for each resident</li>
        </ul>

        <h4>The right candidate will be:</h4>
        <ul className="list">
          <li>Passionate about delivering first-class care</li>
          <li>Patient, kind and understanding</li>
          <li>Reliable and respectful</li>
        </ul>

        <div className="apply-div">
            <Link to="/career/application" className="apply-btn">Apply Now</Link>
        </div>
        
      </div>
    </div>
    <Footer />
    </>
  );
};

export default Career;
